import React, { useState } from 'react';
import { Col, Row, Input, Button, Typography, message } from "antd";
import { useNavigate } from 'react-router-dom';
import api from '../../services/axiosInstance';
import { MAINVERSION } from '../appsettings';

const ResetPassword = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [mobile, setMobile] = useState("");

  const handleReset = () => {
    if (!username.trim() || !mobile.trim()) {
      message.error('Please fill in both fields.');
      return;
    }

    api.post(`/settings/user/passwordreset.php`, {
      username: username.trim(),
      usermobile: mobile.trim()
    })
      .then(response => {
        const dataset = response.data;
        if (dataset["status"] === "success") {
          message.success('Password reset request sent successfully!');
          setUsername("");
          setMobile("");
          setTimeout(() => navigate('/'), 3000);

        } else {
          message.error(dataset["message"]);
        }
      })
      .catch(error => {
        message.error(error.message);
      });
  };

  return (
    <>
      <Row style={{ height: "100vh" }}>
        <Col className="gutter-row bg-dark" xs={24} md={12} style={{ background: 'url("./loginbackground.jpg")' }}>
        </Col>
        <Col className="gutter-row" xs={24} md={12} style={{ backgroundColor: '#d0f5a2', paddingTop: 50 }}>
          <div style={{ maxWidth: 300, margin: "auto", padding: 10 }}>
            <Typography.Title level={3}>Reset Password</Typography.Title>
            <hr />
            <br />
            <Input placeholder="User Name" onChange={(e) => setUsername(e.target.value)} style={{ marginBottom: 20 }} />
            <Input placeholder="Mobile Number" onChange={(e) => setMobile(e.target.value)} style={{ marginBottom: 20 }} />
            <Button onClick={handleReset} type="primary">Reset Password</Button>
            <hr />
            <br />
            <p>AgroLand Management System - Ver {MAINVERSION}</p>
            <p>Developed By : <a href="https://dsoftmedia.com">D Soft Media</a></p>
          </div>

        </Col>
      </Row>
    </>
  );
};

export default ResetPassword;
